import type { Recurrence } from '@lingoda/dates';
import { transChoice } from '@lingoda/i18n';

export const getRecurrencePeriod = (recurrenceInterval?: Recurrence) => {
    if (recurrenceInterval) {
        const { d, m } = recurrenceInterval;

        if (d) {
            return transChoice('per-day', d, { days: d }, 'public-courses');
        } else if (m) {
            return transChoice('per-month', m, { months: m }, 'public-courses');
        }
    }

    return transChoice('per-month', 1, {}, 'public-courses');
};
